import React from 'react'
import { cn } from '~shared/utils/cn'

export const CourseReasons = ({ className }: { className: string }) => {
  const reasons = [
    {
      id: 1,
      title: 'От 2800 рублей в час',
      description: 'в среднем зарабатывает психолог-консультант',
      positionBlock1: 'top-0 right-0'
    },
    {
      id: 2,
      title: 'Стабильный поток клиентов',
      description: 'ежегодный рост запросов на услуги психологов',
      positionBlock1: 'top-0 left-0'
    },
    {
      id: 3,
      title: '2 диплома, 2 специальности',
      description:
        'По окончании обучения вы получите дипломо переподготовке и повышении квалификации',
      positionBlock1: 'bottom-0 right-0'
    },
    {
      id: 4,
      title: 'Удалённо и из любой точки мира',
      description: 'психолог может быть не привязан к месту работы',
      positionBlock1: 'bottom-0 left-0'
    }
  ]
  return (
    <section className={cn('container container-slim box-border', className)}>
      <h2 className='typo-section-heading typo-section-heading-mb'>
        Почему стоит учиться на курсе?
      </h2>
      <div className='grid grid-cols-2 gap-[16px] relative'>
        {reasons.map(el => (
          <div
            className={cn(
              'h-[200px] rounded-[24px] p-[24px] flex flex-col relative',
              el.id % 2 === 0 && 'items-end'
            )}>
            <div
              className={cn(
                'absolute z-[-1] h-[96px] w-[150px] rounded-[24px] bg-[#F2F2F2]',
                el.positionBlock1
              )}
            />
            <div
              className={cn(
                'absolute z-[-1] h-[200px] top-0 w-[calc(100%-104px)] rounded-[24px] bg-[#F2F2F2] left-0',
                el.id % 2 === 0 && 'left-auto right-0'
              )}
            />
            <p>0{el.id}.</p>
            <p className='mt-auto max-w-[400px] text-[24px] font-medium mb-[16px]'>
              {el.title}
            </p>
            <p className='max-w-[500px]'>{el.description}</p>
          </div>
        ))}

        <div className='absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-10'>
          <div className='w-[226px] h-[226px] p-[16px] bg-white rounded-[16px]'>
            <img
              src='/assets/imgs/psychology-course-page/girl-min.jpg'
              alt='girl-min'
            />
          </div>
          <div className='w-[50px] h-[50px] absolute z-[-1] bg-[#F2F2F2] top-[-25px] left-[-25px]' />
          <div className='w-[50px] h-[50px] absolute z-[-1] bg-[#F2F2F2] top-[-25px] right-[-25px]' />
          <div className='w-[50px] h-[50px] absolute z-[-1] bg-[#F2F2F2] bottom-[-25px] left-[-25px]' />
          <div className='w-[50px] h-[50px] absolute z-[-1] bg-[#F2F2F2] bottom-[-25px] right-[-25px]' />
        </div>
      </div>
    </section>
  )
}
